module.exports = __webpack_public_path__ + "img/new_loading.49506b92.gif";